__turbopack_context__.v({
  "root": "AllProducts-module__rSlNcG__root",
  "sidebar": "AllProducts-module__rSlNcG__sidebar",
});
